/**
 * 非同期 KV ストア（同期エンジンの永続化用 / D-0025）
 * -----------------------------------------------------------------------------
 * - createIdbKV: ブラウザの IndexedDB 実装（オフライン同期のキューをブラウザを閉じても保持）。
 * - createMemoryKV: node テスト用のメモリ実装（同一 API）。
 * 値は構造化複製可能なプレーンオブジェクト/配列のみ（sync-engine の base/outbox/conflicts）。
 */

/** テスト用インメモリ KV。 */
export function createMemoryKV(seed) {
  const m = new Map(seed ? Object.entries(seed) : undefined);
  return {
    async get(k) { return m.has(k) ? structuredClone(m.get(k)) : null; },
    async set(k, v) { m.set(k, structuredClone(v)); },
    async del(k) { m.delete(k); },
    async keys() { return [...m.keys()]; },
  };
}

/** IndexedDB 実装。dbName/storeName でネームスペース。 */
export function createIdbKV(dbName = "sheetsnap", storeName = "kv") {
  const dbp = new Promise((resolve, reject) => {
    const req = indexedDB.open(dbName, 1);
    req.onupgradeneeded = () => { if (!req.result.objectStoreNames.contains(storeName)) req.result.createObjectStore(storeName); };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  const run = (mode, fn) => dbp.then((db) => new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, mode);
    const os = tx.objectStore(storeName);
    const r = fn(os);
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  }));
  return {
    get: (k) => run("readonly", (os) => os.get(k)).then((v) => v ?? null),
    set: (k, v) => run("readwrite", (os) => os.put(v, k)).then(() => undefined),
    del: (k) => run("readwrite", (os) => os.delete(k)).then(() => undefined),
    keys: () => run("readonly", (os) => os.getAllKeys()),
  };
}
